module.exports = __webpack_public_path__ + "static/media/Mesa-Centro-.fc38e615.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Section-Productos/Imagen/Mesa-Centro-.png
// module id = 128
// module chunks = 0